export default "__VITE_ASSET__DroIWky___"